(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lsl-box-explorer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lsl-box-explorer')){customElements.define('lsl-box-explorer',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.active=0;this.opened=false;this.points=[...this.querySelectorAll('[data-point]')];this.tabs=[...this.querySelectorAll('[data-select]')];this.panels=[...this.querySelectorAll('[data-panel]')];this.opener=this.querySelector('.lsl-box__open');this.details=this.querySelector('.lsl-box__details');this.opener.addEventListener('click',()=>this.open());this.querySelector('.lsl-box__close').addEventListener('click',()=>this.close());this.points.forEach((b,i)=>{b.addEventListener('click',()=>this.select(i));b.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&this.opened)this.select(i)});b.addEventListener('focus',()=>{if(this.opened)this.select(i)})});this.tabs.forEach((b,i)=>b.addEventListener('click',()=>this.select(i)));this.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>this.select(this.active+Number(b.dataset.step))));this.addEventListener('keydown',e=>{if(!this.opened)return;if(e.key==='Escape'){e.preventDefault();this.close()}if((e.key==='ArrowRight'||e.key==='ArrowLeft')&&e.target.matches('[data-select],[data-point]')){e.preventDefault();this.select(this.active+(e.key==='ArrowRight'?1:-1));this.tabs[this.active].focus()}})}
 open(){if(!this.panels.length)return;this.opened=true;this.classList.add('is-open');this.details.hidden=false;this.querySelector('.lsl-box__points').hidden=false;this.querySelector('.lsl-box__counter').hidden=false;this.opener.setAttribute('aria-expanded','true');this.opener.hidden=true;this.select(0);this.tabs[0].focus({preventScroll:true})}
 close(){this.opened=false;this.classList.remove('is-open');this.details.hidden=true;this.querySelector('.lsl-box__points').hidden=true;this.querySelector('.lsl-box__counter').hidden=true;this.opener.hidden=false;this.opener.setAttribute('aria-expanded','false');this.opener.focus({preventScroll:true})}
 select(index){this.active=(index+this.panels.length)%this.panels.length;this.panels.forEach((p,i)=>p.hidden=i!==this.active);[this.points,this.tabs].forEach(group=>group.forEach((b,i)=>b.setAttribute('aria-expanded',String(i===this.active))));this.querySelector('.lsl-box__counter').textContent=String(this.active+1).padStart(2,'0')+' / '+String(this.panels.length).padStart(2,'0')}
})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsl-home-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lsl-collection-carousel')) {
    customElements.define('lsl-collection-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.track = this.querySelector('.lsl-home-collections__track');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.updateControls = () => {
          const position = Math.abs(this.track.scrollLeft);
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          this.previous.hidden = this.next.hidden = maximum <= 2;
          this.previous.disabled = position <= 5;
          this.next.disabled = position >= maximum - 5;
        };
        const move = direction => {
          const cards = Array.from(this.track.children).filter(card => !card.hidden);
          if (!cards.length) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = cards[0].getBoundingClientRect().width + gap;
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({ left: direction * rtl * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', this.updateControls, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.lsl-home-collections__card');
          if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
        }, options);
        this.resizeObserver = new ResizeObserver(this.updateControls);
        this.resizeObserver.observe(this.track);
        const expireOffer = () => {
          clearTimeout(this.expiryTimer);
          const remaining = Date.parse(this.dataset.offerEnd) - Date.now();
          const offer = this.querySelector('[data-offer]');
          if (!offer) return;
          offer.hidden = !Number.isFinite(remaining) || remaining <= 0;
          if (!offer.hidden) this.expiryTimer = setTimeout(expireOffer, Math.min(remaining, 2147483647));
          this.updateControls();
        };
        expireOffer();
        this.updateControls();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
        clearTimeout(this.expiryTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsl-shooting-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lsl-shooting-gallery')) {
    customElements.define('lsl-shooting-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.track = this.querySelector('[data-gallery-track]');
        this.photos = [...this.querySelectorAll('[data-gallery-photo]')];
        this.dialog = this.querySelector('dialog');
        this.active = 0;
        this.querySelector('[data-gallery-controls]').hidden = false;
        this.addEventListener('click', (event) => {
          const photo = event.target.closest('[data-gallery-photo]');
          const step = event.target.closest('[data-gallery-step]');
          const modalStep = event.target.closest('[data-dialog-step]');
          if (photo && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0 && this.dialog.showModal) {
            event.preventDefault();
            this.opener = photo;
            this.showPhoto(this.photos.indexOf(photo));
            this.dialog.showModal();
          }
          if (step) this.moveTrack(Number(step.dataset.galleryStep));
          if (modalStep) this.showPhoto(this.active + Number(modalStep.dataset.dialogStep));
          if (event.target.closest('[data-dialog-close]') || event.target === this.dialog) this.dialog.close();
        }, { signal });
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.updateTrack(); });
        }, { signal, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.moveTrack(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(this.active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        this.dialog.addEventListener('close', () => {
          this.querySelector('[data-dialog-figure]').replaceChildren();
          this.opener?.focus({ preventScroll: true });
        }, { signal });
        this.observer = new ResizeObserver(() => this.updateTrack());
        this.observer.observe(this.track);
        document.addEventListener('shopify:block:select', (event) => {
          if (this.contains(event.target)) event.target.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
        }, { signal });
        this.updateTrack();
      }
      moveTrack(step) {
        const width = this.photos[0].parentElement.getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: step * (width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      updateTrack() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.max(0, this.track.scrollLeft);
        const width = this.photos[0].parentElement.getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const index = Math.min(this.photos.length, Math.round(position / (width + gap)) + 1);
        this.querySelector('[data-gallery-count]').textContent = `${index} / ${this.photos.length}`;
        this.querySelector('[data-gallery-step="-1"]').disabled = position <= 4;
        this.querySelector('[data-gallery-step="1"]').disabled = position >= maximum - 2;
        this.querySelector('[data-gallery-progress]').style.width = `${Math.min(100, ((position + this.track.clientWidth) / this.track.scrollWidth) * 100)}%`;
      }
      showPhoto(index) {
        this.active = (index + this.photos.length) % this.photos.length;
        const source = this.photos[this.active];
        const photo = new Image();
        photo.alt = source.querySelector('img').alt;
        photo.src = source.href;
        photo.decoding = 'async';
        this.querySelector('[data-dialog-figure]').replaceChildren(photo);
        this.querySelector('[data-dialog-count]').textContent = `${this.active + 1} / ${this.photos.length}`;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsl-store-reviews"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('lsl-review-selection')) {
    customElements.define('lsl-review-selection', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        this.activeCards = this.cards;
        this.page = 0;
        this.mobile = window.matchMedia('(max-width:600px)');
        this.tablet = window.matchMedia('(max-width:899px)');
        this.size = () => this.mobile.matches ? 1 : this.tablet.matches ? 2 : 3;
        this.previous = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.status = this.querySelector('[data-review-status]');
        this.dialog = this.querySelector('[data-review-dialog]');
        this.fullImage = this.querySelector('[data-review-full-image]');
        this.fullVideo = this.querySelector('[data-review-full-video]');
        this.classList.add('is-ready');
        this.querySelector('nav').hidden = false;
        this.querySelector('.lsl-reviews__filters').hidden = false;
        this.querySelectorAll('[data-review-expand]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            const open = button.getAttribute('aria-expanded') !== 'true';
            button.setAttribute('aria-expanded', String(open));
            button.closest('[data-review-card]').classList.toggle('is-expanded', open);
            button.textContent = open ? button.dataset.less : button.dataset.more;
          }, options);
        });
        this.querySelectorAll('[data-review-filter]').forEach(button => {
          button.addEventListener('click', () => {
            this.activeCards = button.dataset.reviewFilter === 'media' ? this.cards.filter(card => card.querySelector('[data-review-media]')) : this.cards;
            this.querySelectorAll('[data-review-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            this.page = 0;
            this.render();
          }, options);
        });
        const triggers = [...this.querySelectorAll('[data-review-media]'), ...document.querySelectorAll('.lsl-review-highlight [data-review-media]')];
        triggers.forEach(trigger => trigger.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.openMedia(trigger);
        }, options));
        this.previous.addEventListener('click', () => this.change(-1), options);
        this.next.addEventListener('click', () => this.change(1), options);
        this.onResize = () => { this.page = 0; this.render(); };
        this.mobile.addEventListener('change', this.onResize);
        this.tablet.addEventListener('change', this.onResize);
        this.querySelector('[data-review-media-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-review-media-prev]').addEventListener('click', () => this.showMedia(this.mediaIndex - 1), options);
        this.querySelector('[data-review-media-next]').addEventListener('click', () => this.showMedia(this.mediaIndex + 1), options);
        this.dialog.addEventListener('close', () => {
          this.resetVideo();
          this.fullImage.removeAttribute('src');
          this.mediaTrigger?.focus({preventScroll:true});
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.target.closest('video')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showMedia(this.mediaIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.render();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.mobile?.removeEventListener('change', this.onResize);
        this.tablet?.removeEventListener('change', this.onResize);
        if (this.dialog?.open) this.dialog.close();
        if (this.fullVideo) this.resetVideo();
        this.ready = false;
      }
      change(direction) {
        this.page = Math.max(0, Math.min(Math.ceil(this.activeCards.length / this.size()) - 1, this.page + direction));
        this.render();
      }
      render() {
        const start = this.page * this.size();
        const visible = new Set(this.activeCards.slice(start, start + this.size()));
        this.cards.forEach(card => { card.hidden = !visible.has(card); });
        this.previous.disabled = this.page === 0;
        this.next.disabled = start + this.size() >= this.activeCards.length;
        this.status.textContent = this.status.dataset.pattern.replace('[first]', this.activeCards.length ? start + 1 : 0).replace('[last]', Math.min(start + this.size(), this.activeCards.length)).replace('[total]', this.activeCards.length);
      }
      openMedia(trigger) {
        this.mediaTrigger = trigger;
        const card = trigger.closest('[data-review-card], .lsl-review-highlight');
        this.mediaItems = [...card.querySelectorAll('[data-review-media]')];
        this.querySelector('[data-review-media-title]').textContent = this.querySelector('[data-review-media-title]').dataset.pattern.replace('[author]', trigger.dataset.mediaAuthor);
        const thumbs = this.querySelector('[data-review-media-thumbs]');
        thumbs.replaceChildren();
        if (this.mediaItems.length > 1) {
          this.mediaItems.forEach((item, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('aria-label', item.getAttribute('aria-label'));
            button.setAttribute('aria-pressed', 'false');
            const preview = item.querySelector('img');
            if (preview) {
              const image = preview.cloneNode();
              image.removeAttribute('id');
              image.width = 60;
              image.height = 54;
              button.append(image);
            }
            if (item.dataset.mediaType === 'video') {
              const icon = document.createElement('span');
              icon.textContent = '▶';
              icon.setAttribute('aria-hidden', 'true');
              button.append(icon);
            }
            button.addEventListener('click', () => this.showMedia(index));
            thumbs.append(button);
          });
        }
        this.dialog.showModal();
        this.showMedia(this.mediaItems.indexOf(trigger));
      }
      resetVideo() {
        this.fullVideo.pause();
        this.fullVideo.removeAttribute('src');
        this.fullVideo.removeAttribute('poster');
        this.fullVideo.load();
      }
      showMedia(index) {
        this.mediaIndex = Math.max(0, Math.min(this.mediaItems.length - 1, index));
        const item = this.mediaItems[this.mediaIndex];
        this.resetVideo();
        const isVideo = item.dataset.mediaType === 'video';
        this.fullImage.hidden = isVideo;
        this.fullVideo.hidden = !isVideo;
        if (isVideo) {
          this.fullImage.removeAttribute('src');
          if (item.dataset.mediaPoster) this.fullVideo.poster = item.dataset.mediaPoster;
          this.fullVideo.src = item.dataset.mediaSrc;
          this.fullVideo.load();
          this.fullVideo.play().catch(() => {});
        } else {
          this.fullImage.src = item.dataset.mediaSrc;
          this.fullImage.alt = item.querySelector('img')?.alt || item.getAttribute('aria-label');
        }
        this.querySelector('[data-review-media-prev]').disabled = this.mediaIndex === 0;
        this.querySelector('[data-review-media-next]').disabled = this.mediaIndex === this.mediaItems.length - 1;
        const status = this.querySelector('[data-review-media-status]');
        status.textContent = status.dataset.pattern.replace('[current]', this.mediaIndex + 1).replace('[total]', this.mediaItems.length);
        [...this.querySelector('[data-review-media-thumbs]').children].forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.mediaIndex)));
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsl-unboxings"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lsl-unboxing-gallery')) {
    customElements.define('lsl-unboxing-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.lsl-unboxings__track');
        this.cards = [...this.querySelectorAll('[data-video-card]')];
        this.links = this.cards.map(card => card.querySelector('[data-video-open]'));
        this.dialog = this.querySelector('dialog');
        if (!this.track || !this.dialog || !this.cards.length) return;
        this.video = this.dialog.querySelector('video');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.querySelector('.lsl-unboxings__nav').hidden = false;
        this.links.forEach((link, index) => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.opener = link;
          this.index = index;
          this.loadVideo();
          if (!this.dialog.open) this.dialog.showModal();
          this.playVideo();
        }, options));
        this.querySelector('[data-video-previous]').addEventListener('click', () => this.scrollCards(-this.visibleCount()), options);
        this.querySelector('[data-video-next]').addEventListener('click', () => this.scrollCards(this.visibleCount()), options);
        this.querySelector('[data-video-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-modal-previous]').addEventListener('click', () => this.changeVideo(-1), options);
        this.querySelector('[data-modal-next]').addEventListener('click', () => this.changeVideo(1), options);
        this.track.addEventListener('scroll', () => this.scheduleRange(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.scrollCards(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.scrollBehavior() });
          }
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.target === this.video) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.changeVideo(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          this.clearVideo();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
        this.video.addEventListener('canplay', () => { this.querySelector('[data-video-loading]').hidden = true; }, options);
        this.video.addEventListener('error', () => {
          if (!this.video.getAttribute('src')) return;
          this.querySelector('[data-video-loading]').hidden = true;
          this.querySelector('[data-video-error]').hidden = false;
        }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden && this.dialog.open) this.dialog.close(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-video-card]');
          if (card?.closest('lsl-unboxing-gallery') !== this) return;
          this.track.scrollTo({ left: this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'auto' });
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.scheduleRange());
        this.resizeObserver.observe(this.track);
        this.updateRange();
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.revealObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:320,easing:'ease-out'});
              this.revealObserver.unobserve(entry.target);
            });
          }, {threshold:.15});
          this.querySelectorAll('.lsl-unboxings__header, .lsl-unboxings__card').forEach(el => this.revealObserver.observe(el));
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.revealObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.video) this.clearVideo();
        if (this.dialog?.open) this.dialog.close();
      }
      scrollBehavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      stepSize() { return this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0); }
      visibleCount() { return Math.max(1, Math.floor((this.track.clientWidth + (parseFloat(getComputedStyle(this.track).columnGap) || 0)) / this.stepSize())); }
      scrollCards(count) { this.track.scrollBy({ left: this.stepSize() * count, behavior: this.scrollBehavior() }); }
      scheduleRange() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => { this.frame = null; if (this.isConnected) this.updateRange(); });
      }
      updateRange() {
        const start = Math.min(this.cards.length - 1, Math.max(0, Math.round(this.track.scrollLeft / this.stepSize())));
        const end = Math.min(this.cards.length, start + this.visibleCount());
        this.querySelector('[data-video-range]').textContent = this.dataset.range.replace('__START__', start + 1).replace('__END__', end).replace('__TOTAL__', this.cards.length);
        this.querySelector('[data-video-previous]').disabled = this.track.scrollLeft < 3;
        this.querySelector('[data-video-next]').disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 3;
      }
      clearVideo() {
        this.querySelector('[data-youtube-player]').replaceChildren();
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.removeAttribute('poster');
        this.video.load();
      }
      loadVideo() {
        this.clearVideo();
        const link = this.links[this.index];
        this.querySelector('[data-video-title]').textContent = link.dataset.title;
        this.querySelector('[data-video-position]').textContent = this.dataset.position.replace('__CURRENT__', this.index + 1).replace('__TOTAL__', this.cards.length);
        this.querySelector('[data-video-loading]').hidden = false;
        this.querySelector('[data-video-error]').hidden = true;
        this.querySelector('[data-modal-previous]').disabled = this.index === 0;
        this.querySelector('[data-modal-next]').disabled = this.index === this.cards.length - 1;
        this.querySelector('[data-video-original]').href = link.href;
        this.dialog.classList.toggle('lsl-unboxings__dialog--wide', link.dataset.landscape === 'true');
        const youtubePlayer = this.querySelector('[data-youtube-player]');
        youtubePlayer.hidden = !link.dataset.youtube;
        this.video.hidden = !!link.dataset.youtube;
        if (link.dataset.youtube) {
          const frame = document.createElement('iframe');
          frame.title = link.dataset.title;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.src = 'https://www.youtube-nocookie.com/embed/' + link.dataset.youtube + '?autoplay=1&rel=0&playsinline=1';
          frame.addEventListener('load', () => { this.querySelector('[data-video-loading]').hidden = true; }, { once: true });
          youtubePlayer.append(frame);
          return;
        }
        if (link.dataset.poster) this.video.poster = link.dataset.poster;
        this.video.src = link.href;
        this.video.load();
      }
      playVideo() {
        if (this.video.hidden) return;
        const pending = this.video.play();
        pending?.catch(() => { if (this.video.readyState >= 2) this.querySelector('[data-video-loading]').hidden = true; });
      }
      changeVideo(delta) {
        const next = this.index + delta;
        if (next < 0 || next >= this.links.length) return;
        this.index = next;
        this.loadVideo();
        this.playVideo();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsl-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lsl-video-testimonials')) {
    customElements.define('lsl-video-testimonials', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.lsl-client-videos__track');
        this.cards = [...this.querySelectorAll('[data-video-card]')];
        this.links = this.cards.map(card => card.querySelector('[data-video-open]'));
        this.dialog = this.querySelector('dialog');
        if (!this.track || !this.dialog || !this.cards.length) return;
        this.video = this.dialog.querySelector('video');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.querySelector('.lsl-client-videos__nav').hidden = false;
        this.links.forEach((link, index) => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.opener = link;
          this.index = index;
          this.loadVideo();
          if (!this.dialog.open) this.dialog.showModal();
          this.playVideo();
        }, options));
        this.querySelector('[data-video-previous]').addEventListener('click', () => this.scrollCards(-this.visibleCount()), options);
        this.querySelector('[data-video-next]').addEventListener('click', () => this.scrollCards(this.visibleCount()), options);
        this.querySelector('[data-video-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-modal-previous]').addEventListener('click', () => this.changeVideo(-1), options);
        this.querySelector('[data-modal-next]').addEventListener('click', () => this.changeVideo(1), options);
        this.track.addEventListener('scroll', () => this.scheduleRange(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.scrollCards(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.scrollBehavior() });
          }
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.target === this.video) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.changeVideo(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          this.clearVideo();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
        this.video.addEventListener('canplay', () => { this.querySelector('[data-video-loading]').hidden = true; }, options);
        this.video.addEventListener('error', () => {
          if (!this.video.getAttribute('src')) return;
          this.querySelector('[data-video-loading]').hidden = true;
          this.querySelector('[data-video-error]').hidden = false;
        }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-video-card]');
          if (card?.closest('lsl-video-testimonials') !== this) return;
          this.track.scrollTo({ left: this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'auto' });
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.scheduleRange());
        this.resizeObserver.observe(this.track);
        this.updateRange();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.video) this.clearVideo();
        if (this.dialog?.open) this.dialog.close();
      }
      scrollBehavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      stepSize() { return this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0); }
      visibleCount() { return Math.max(1, Math.floor((this.track.clientWidth + (parseFloat(getComputedStyle(this.track).columnGap) || 0)) / this.stepSize())); }
      scrollCards(count) { this.track.scrollBy({ left: this.stepSize() * count, behavior: this.scrollBehavior() }); }
      scheduleRange() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => { this.frame = null; if (this.isConnected) this.updateRange(); });
      }
      updateRange() {
        const start = Math.min(this.cards.length - 1, Math.max(0, Math.round(this.track.scrollLeft / this.stepSize())));
        const end = Math.min(this.cards.length, start + this.visibleCount());
        this.querySelector('[data-video-range]').textContent = this.dataset.range.replace('__START__', start + 1).replace('__END__', end).replace('__TOTAL__', this.cards.length);
        this.querySelector('[data-video-previous]').disabled = this.track.scrollLeft < 3;
        this.querySelector('[data-video-next]').disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 3;
      }
      clearVideo() {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.removeAttribute('poster');
        this.video.load();
      }
      loadVideo() {
        this.clearVideo();
        const link = this.links[this.index];
        this.querySelector('[data-video-title]').textContent = link.dataset.title;
        this.querySelector('[data-video-position]').textContent = this.dataset.position.replace('__CURRENT__', this.index + 1).replace('__TOTAL__', this.cards.length);
        this.querySelector('[data-video-loading]').hidden = false;
        this.querySelector('[data-video-error]').hidden = true;
        this.querySelector('[data-modal-previous]').disabled = this.index === 0;
        this.querySelector('[data-modal-next]').disabled = this.index === this.cards.length - 1;
        this.querySelector('[data-video-original]').href = link.href;
        if (link.dataset.poster) this.video.poster = link.dataset.poster;
        this.video.src = link.href;
        this.video.load();
      }
      playVideo() {
        const pending = this.video.play();
        pending?.catch(() => { if (this.video.readyState >= 2) this.querySelector('[data-video-loading]').hidden = true; });
      }
      changeVideo(delta) {
        const next = this.index + delta;
        if (next < 0 || next >= this.links.length) return;
        this.index = next;
        this.loadVideo();
        this.playVideo();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
